module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_1.9b5a48b9.png";